
angular.module('bmsApp.employeeEmergencyDetail').factory('EmployeeEmergencyDetailSvc', function (CRUDSvc, EMPLOYEE_EMERGENCY_DETAIL_API) {

	return {
		create: function (employeeEmergencyDetail) {
			return CRUDSvc.post(EMPLOYEE_EMERGENCY_DETAIL_API.CREATE, employeeEmergencyDetail);
		},
		read: function (id) {
			return CRUDSvc.get(EMPLOYEE_EMERGENCY_DETAIL_API.READ + id);
		},
		update: function (id, employeeEmergencyDetail) {
			return CRUDSvc.post(EMPLOYEE_EMERGENCY_DETAIL_API.UPDATE + id, employeeEmergencyDetail);
		},
		delete: function (id) {
			return CRUDSvc.get(EMPLOYEE_EMERGENCY_DETAIL_API.DELETE + id);
		},
		byEmployee: function (employeeId) {
			return CRUDSvc.get(EMPLOYEE_EMERGENCY_DETAIL_API.BY_EMPLOYEE + employeeId);
		}
	};

}).constant('EMPLOYEE_EMERGENCY_DETAIL_API', {
	CREATE: 'api/employeeEmergencyDetail/create',
	READ: 'api/employeeEmergencyDetail/read/',
	UPDATE: 'api/employeeEmergencyDetail/update/',
	DELETE: 'api/employeeEmergencyDetail/delete/',
	BY_EMPLOYEE: 'api/employeeEmergencyDetail/byEmployee/'
});
